import type { Language } from "@newgenerated/shared/schema";

export const generatedRoutes = {
  blank: [
    {
      path: `${encodeURI("actionables")}/${encodeURI("admin")}`,
      alias: `${encodeURI("actionables")}/${encodeURI("admin")}` === `actionables/admin` ? [] : [`actionables/admin`],
      name: `actionables-admin`,
      component: async () => (await import("@generated-routes/designPages/ActionableOverviewRouterPage")).ActionableOverviewRouterPage,
      meta: {
        title: "Actionables Admin",
      },
      props: true,
    },
    {
      path: `${encodeURI("actionables")}/${encodeURI("generateCertificateTest")}`,
      alias: `${encodeURI("actionables")}/${encodeURI("generateCertificateTest")}` === `actionables/generateCertificateTest` ? [] : [`actionables/generateCertificateTest`],
      name: `certificate-test`,
      component: async () => (await import("@generated-routes/designPages/ActionableCertificateTestRouterPage")).ActionableCertificateTestRouterPage,
      meta: {
        title: "Certificate Test",
      },
      props: true,
    },
    {
      path: `${encodeURI("actionables")}/:actionableId/${encodeURI("admin")}`,
      alias: `${encodeURI("actionables")}/:actionableId/${encodeURI("admin")}` === `actionables/:actionableId/admin` ? [] : [`actionables/:actionableId/admin`],
      name: `actionable-edit`,
      component: async () => (await import("@generated-routes/designPages/ActionableEditRouterPage")).ActionableEditRouterPage,
      meta: {
        title: "Actionable Edit",
      },
      props: true,
    },
    {
      path: `${encodeURI("admin-spa")}/${encodeURI("all-abstracts")}`,
      alias: `${encodeURI("admin-spa")}/${encodeURI("all-abstracts")}` === `admin-spa/all-abstracts` ? [] : [`admin-spa/all-abstracts`],
      name: `all-abstracts-main-page`,
      component: async () => (await import("@generated-routes/designPages/AllAbstractsRouterPage")).AllAbstractsRouterPage,
      meta: {
        title: "All Abstracts Main Page",
      },
      props: true,
    },
    {
      path: `${encodeURI("admin-spa")}/${encodeURI("demo")}/${encodeURI("collapse")}`,
      alias: `${encodeURI("admin-spa")}/${encodeURI("demo")}/${encodeURI("collapse")}` === `admin-spa/demo/collapse` ? [] : [`admin-spa/demo/collapse`],
      name: `demo-collapse`,
      component: async () => (await import("@generated-routes/designPages/DemoCollapseRouterPage")).DemoCollapseRouterPage,
      meta: {
        title: "Demo Collapse",
      },
      props: true,
    },
    {
      path: `${encodeURI("admin-spa")}/${encodeURI("demo")}/${encodeURI("form")}`,
      alias: `${encodeURI("admin-spa")}/${encodeURI("demo")}/${encodeURI("form")}` === `admin-spa/demo/form` ? [] : [`admin-spa/demo/form`],
      name: `demo-form`,
      component: async () => (await import("@generated-routes/designPages/DemoFormRouterPage")).DemoFormRouterPage,
      meta: {
        title: "Demo Form",
      },
      props: true,
    },
    {
      path: `${encodeURI("admin-spa")}/${encodeURI("demo")}/${encodeURI("form-generated")}`,
      alias: `${encodeURI("admin-spa")}/${encodeURI("demo")}/${encodeURI("form-generated")}` === `admin-spa/demo/form-generated` ? [] : [`admin-spa/demo/form-generated`],
      name: `demo-generated-form`,
      component: async () => (await import("@generated-routes/designPages/DemoGeneratedFormRouterPage")).DemoGeneratedFormRouterPage,
      meta: {
        title: "Demo Generated Form",
      },
      props: true,
    },
    {
      path: `${encodeURI("admin-spa")}/${encodeURI("demo")}/${encodeURI("pagination")}`,
      alias: `${encodeURI("admin-spa")}/${encodeURI("demo")}/${encodeURI("pagination")}` === `admin-spa/demo/pagination` ? [] : [`admin-spa/demo/pagination`],
      name: `demo-pagination`,
      component: async () => (await import("@generated-routes/designPages/DemoPaginationRouterPage")).DemoPaginationRouterPage,
      meta: {
        title: "Demo Pagination",
      },
      props: true,
    },
    {
      path: `${encodeURI("careers")}/${encodeURI("admin")}`,
      alias: `${encodeURI("careers")}/${encodeURI("admin")}` === `careers/admin` ? [] : [`careers/admin`],
      name: `careers-overview`,
      component: async () => (await import("@generated-routes/designPages/CareerOverviewRouterPage")).CareerOverviewRouterPage,
      meta: {
        title: "Careers Overview",
      },
      props: true,
    },
    {
      path: `${encodeURI("careers")}/:careerId/${encodeURI("admin")}`,
      alias: `${encodeURI("careers")}/:careerId/${encodeURI("admin")}` === `careers/:careerId/admin` ? [] : [`careers/:careerId/admin`],
      name: `careers-edit`,
      component: async () => (await import("@generated-routes/designPages/CareerEditRouterPage")).CareerEditRouterPage,
      meta: {
        title: "Careers Edit",
      },
      props: true,
    },
    {
      path: `${encodeURI("channels")}/${encodeURI("featured")}/${encodeURI("admin")}`,
      alias: `${encodeURI("channels")}/${encodeURI("featured")}/${encodeURI("admin")}` === `channels/featured/admin` ? [] : [`channels/featured/admin`],
      name: `featured-channel-admin`,
      component: async () => (await import("@generated-routes/designPages/FeaturedChannelAdminRouterPage")).FeaturedChannelAdminRouterPage,
      meta: {
        title: "Featured Channel Admin",
      },
      props: true,
    },
    {
      path: `${encodeURI("content-production")}/:contentProductionStepId(\\d+)?`,
      alias: `${encodeURI("content-production")}/:contentProductionStepId(\\d+)?` === `content-production/:contentProductionStepId` ? [] : [`content-production/:contentProductionStepId`],
      name: `content-production`,
      component: async () => (await import("@generated-routes/designPages/ContentProductionRouterPage")).ContentProductionRouterPage,
      meta: {
        title: "Content Production",
      },
      props: true,
    },
    {
      path: `${encodeURI("custom-pages")}/${encodeURI("admin")}`,
      alias: `${encodeURI("custom-pages")}/${encodeURI("admin")}` === `custom-pages/admin` ? [] : [`custom-pages/admin`],
      name: `custom-page-global-admin`,
      component: async () => (await import("@generated-routes/designPages/CustomPageOverviewGlobalRouterPage")).CustomPageOverviewGlobalRouterPage,
      meta: {
        title: "Custom Page Global Admin",
      },
      props: true,
    },
    {
      path: `${encodeURI("customers")}/${encodeURI("admin")}`,
      alias: `${encodeURI("customers")}/${encodeURI("admin")}` === `customers/admin` ? [] : [`customers/admin`],
      name: `customer-admin-search`,
      component: async () => (await import("@generated-routes/designPages/CustomerAdminPageRouterPage")).CustomerAdminPageRouterPage,
      meta: {
        title: "Customer Admin Search",
      },
      props: true,
    },
    {
      path: `${encodeURI("design-spa")}`,
      alias: `${encodeURI("design-spa")}` === `design-spa` ? [] : [`design-spa`],
      name: `demo-1`,
      component: async () => (await import("@generated-routes/designPages/Demo1RouterPage")).Demo1RouterPage,
      meta: {
        title: "Demo1",
      },
      props: true,
    },
    {
      path: `${encodeURI("design-spa")}/${encodeURI("demo")}`,
      alias: `${encodeURI("design-spa")}/${encodeURI("demo")}` === `design-spa/demo` ? [] : [`design-spa/demo`],
      name: `demo-2`,
      component: async () => (await import("@generated-routes/designPages/Demo2RouterPage")).Demo2RouterPage,
      meta: {
        title: "Demo2",
      },
      props: true,
    },
    {
      path: `${encodeURI("email-monitoring")}/${encodeURI("admin")}`,
      alias: `${encodeURI("email-monitoring")}/${encodeURI("admin")}` === `email-monitoring/admin` ? [] : [`email-monitoring/admin`],
      name: `email-monitoring`,
      component: async () => (await import("@generated-routes/designPages/EmailMonitoringOverviewRouterPage")).EmailMonitoringOverviewRouterPage,
      meta: {
        title: "Email Monitoring",
      },
      props: true,
    },
    {
      path: `${encodeURI("email-tool")}`,
      alias: `${encodeURI("email-tool")}` === `email-tool` ? [] : [`email-tool`],
      redirect: "email-tool/repositories",
    },
    {
      path: `${encodeURI("email-tool")}/${encodeURI("categories")}/:categoryId`,
      alias: `${encodeURI("email-tool")}/${encodeURI("categories")}/:categoryId` === `email-tool/categories/:categoryId` ? [] : [`email-tool/categories/:categoryId`],
      name: `email-category-edit`,
      component: async () => (await import("@generated-routes/designPages/EmailCategoryEditRouterPage")).EmailCategoryEditRouterPage,
      meta: {
        title: "Email Category Edit",
      },
      props: true,
    },
    {
      path: `${encodeURI("email-tool")}/${encodeURI("categories")}/:categoryId/${encodeURI("templates")}`,
      alias: `${encodeURI("email-tool")}/${encodeURI("categories")}/:categoryId/${encodeURI("templates")}` === `email-tool/categories/:categoryId/templates` ? [] : [`email-tool/categories/:categoryId/templates`],
      name: `email-template-entrypoint`,
      component: async () => (await import("@generated-routes/designPages/EmailTemplateEditRouterPage")).EmailTemplateEditRouterPage,
      meta: {
        title: "Email Template Entrypoint",
      },
      props: true,
    },
    {
      path: `${encodeURI("email-tool")}/${encodeURI("categories")}/:categoryId/${encodeURI("templates")}/:templateId`,
      alias:
        `${encodeURI("email-tool")}/${encodeURI("categories")}/:categoryId/${encodeURI("templates")}/:templateId` === `email-tool/categories/:categoryId/templates/:templateId`
          ? []
          : [`email-tool/categories/:categoryId/templates/:templateId`],
      name: `email-template-edit`,
      component: async () => (await import("@generated-routes/designPages/EmailTemplateEditRouterPage")).EmailTemplateEditRouterPage,
      meta: {
        title: "Email Template Edit",
      },
      props: true,
    },
    {
      path: `${encodeURI("email-tool")}/${encodeURI("email-pools")}`,
      alias: `${encodeURI("email-tool")}/${encodeURI("email-pools")}` === `email-tool/email-pools` ? [] : [`email-tool/email-pools`],
      redirect: "email-tool/pools",
    },
    {
      path: `${encodeURI("email-tool")}/${encodeURI("email-repositories")}`,
      alias: `${encodeURI("email-tool")}/${encodeURI("email-repositories")}` === `email-tool/email-repositories` ? [] : [`email-tool/email-repositories`],
      redirect: "email-tool/repositories",
    },
    {
      path: `${encodeURI("email-tool")}/${encodeURI("pools")}`,
      alias: `${encodeURI("email-tool")}/${encodeURI("pools")}` === `email-tool/pools` ? [] : [`email-tool/pools`],
      name: `email-pools`,
      component: async () => (await import("@generated-routes/designPages/EmailPoolsPageRouterPage")).EmailPoolsPageRouterPage,
      meta: {
        title: "Email Pools",
      },
      props: true,
    },
    {
      path: `${encodeURI("email-tool")}/${encodeURI("repositories")}`,
      alias: `${encodeURI("email-tool")}/${encodeURI("repositories")}` === `email-tool/repositories` ? [] : [`email-tool/repositories`],
      name: `email-repositories`,
      component: async () => (await import("@generated-routes/designPages/EmailRepositoriesRouterPage")).EmailRepositoriesRouterPage,
      meta: {
        title: "Email Repositories",
      },
      props: true,
    },
    {
      path: `${encodeURI("email-tool")}/${encodeURI("repositories")}/:repositoryId`,
      alias: `${encodeURI("email-tool")}/${encodeURI("repositories")}/:repositoryId` === `email-tool/repositories/:repositoryId` ? [] : [`email-tool/repositories/:repositoryId`],
      redirect: "email-tool/repositories/:repositoryId/categories",
    },
    {
      path: `${encodeURI("email-tool")}/${encodeURI("repositories")}/:repositoryId/${encodeURI("categories")}`,
      alias: `${encodeURI("email-tool")}/${encodeURI("repositories")}/:repositoryId/${encodeURI("categories")}` === `email-tool/repositories/:repositoryId/categories` ? [] : [`email-tool/repositories/:repositoryId/categories`],
      name: `email-categories`,
      component: async () => (await import("@generated-routes/designPages/EmailCategoriesRouterPage")).EmailCategoriesRouterPage,
      meta: {
        title: "Email Categories",
      },
      props: true,
    },
    {
      path: `${encodeURI("explore")}/${encodeURI("iframe")}`,
      alias: `${encodeURI("explore")}/${encodeURI("iframe")}` === `explore/iframe` ? [] : [`explore/iframe`],
      name: `explore-skills-taxonomy-iframe`,
      component: async () => (await import("@generated-routes/designPages/ExploreSkillsPageRouterPage")).ExploreSkillsPageRouterPage,
      meta: {
        title: "Explore Skills Taxonomy",
        iframe: true,
      },
      props: true,
    },
    {
      path: `${encodeURI("finance")}/${encodeURI("revenue-report")}`,
      alias: `${encodeURI("finance")}/${encodeURI("revenue-report")}` === `finance/revenue-report` ? [] : [`finance/revenue-report`],
      name: `revenue-report`,
      component: async () => (await import("@generated-routes/designPages/RevenueReportVue2WrapperRouterPage")).RevenueReportVue2WrapperRouterPage,
      meta: {
        title: "Revenue Report",
      },
      props: true,
    },
    {
      path: `${encodeURI("marketing")}/${encodeURI("fileupload")}`,
      alias: `${encodeURI("marketing")}/${encodeURI("fileupload")}` === `marketing/fileupload` ? [] : [`marketing/fileupload`],
      name: `marketing-file-upload`,
      component: async () => (await import("@generated-routes/designPages/MarketingFileUploadPageRouterPage")).MarketingFileUploadPageRouterPage,
      meta: {
        title: "Marketing File Upload",
      },
      props: true,
    },
    {
      path: `${encodeURI("peerinsight")}/${encodeURI("admin")}`,
      alias: `${encodeURI("peerinsight")}/${encodeURI("admin")}` === `peerinsight/admin` ? [] : [`peerinsight/admin`],
      name: `peer-insight-answers`,
      component: async () => (await import("@generated-routes/designPages/PeerInsightOverviewRouterPage")).PeerInsightOverviewRouterPage,
      meta: {
        title: "Peer Insight Answers",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)`,
      alias: `${encodeURI("portal-admin")}/:corporateId(\\d+)` === `portal-admin/:corporateId` ? [] : [`portal-admin/:corporateId`],
      name: `portal-admin`,
      component: async () => (await import("@generated-routes/designPages/LibraryPulsePageRouterPage")).LibraryPulsePageRouterPage,
      meta: {
        title: "What's new",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("connectors")}/${encodeURI("connector-completion-execution-logs")}`,
      alias:
        `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("connectors")}/${encodeURI("connector-completion-execution-logs")}` === `portal-admin/:corporateId/connectors/connector-completion-execution-logs`
          ? []
          : [`portal-admin/:corporateId/connectors/connector-completion-execution-logs`],
      name: `connector-execution-logs`,
      component: async () => (await import("@generated-routes/designPages/ConnectorCompletionExecutionLogsAdminRouterPage")).ConnectorCompletionExecutionLogsAdminRouterPage,
      meta: {
        title: "Connectors (Execution Logs)",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("connectors")}/${encodeURI("connector-content-executions")}`,
      alias:
        `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("connectors")}/${encodeURI("connector-content-executions")}` === `portal-admin/:corporateId/connectors/connector-content-executions`
          ? []
          : [`portal-admin/:corporateId/connectors/connector-content-executions`],
      name: `connector-content-executions`,
      component: async () => (await import("@generated-routes/designPages/ConnectorContentExecutionsAdminRouterPage")).ConnectorContentExecutionsAdminRouterPage,
      meta: {
        title: "Connectors (Executions)",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("connectors")}/${encodeURI("connectors")}`,
      alias: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("connectors")}/${encodeURI("connectors")}` === `portal-admin/:corporateId/connectors/connectors` ? [] : [`portal-admin/:corporateId/connectors/connectors`],
      name: `connectors`,
      component: async () => (await import("@generated-routes/designPages/ConnectorsAdminRouterPage")).ConnectorsAdminRouterPage,
      meta: {
        title: "Connectors",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("curatingContent")}/${encodeURI("custom-pages")}`,
      alias:
        `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("curatingContent")}/${encodeURI("custom-pages")}` === `portal-admin/:corporateId/curatingContent/custom-pages`
          ? []
          : [`portal-admin/:corporateId/curatingContent/custom-pages`],
      name: `curating-content-custom-pages`,
      component: async () => (await import("@generated-routes/designPages/CustomPagesRouterPage")).CustomPagesRouterPage,
      meta: {
        title: "CuratingContent (Custom Pages)",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("curatingContent")}/${encodeURI("sensitive-content")}`,
      alias:
        `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("curatingContent")}/${encodeURI("sensitive-content")}` === `portal-admin/:corporateId/curatingContent/sensitive-content`
          ? []
          : [`portal-admin/:corporateId/curatingContent/sensitive-content`],
      name: `curating-content-sensitive-content`,
      component: async () => (await import("@generated-routes/designPages/CorporateSensitiveContentRouterPage")).CorporateSensitiveContentRouterPage,
      meta: {
        title: "CuratingContent (Sensitive Content)",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("curatingContent")}/${encodeURI("sensitive-tags")}`,
      alias:
        `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("curatingContent")}/${encodeURI("sensitive-tags")}` === `portal-admin/:corporateId/curatingContent/sensitive-tags`
          ? []
          : [`portal-admin/:corporateId/curatingContent/sensitive-tags`],
      name: `sensitive-tags`,
      component: async () => (await import("@generated-routes/designPages/SensitiveTagsRouterPage")).SensitiveTagsRouterPage,
      meta: {
        title: "Sensitive Tags",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("custom-pages")}/:customPageId/${encodeURI("admin")}`,
      alias:
        `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("custom-pages")}/:customPageId/${encodeURI("admin")}` === `portal-admin/:corporateId/custom-pages/:customPageId/admin`
          ? []
          : [`portal-admin/:corporateId/custom-pages/:customPageId/admin`],
      name: `custom-page-admin`,
      component: async () => (await import("@generated-routes/designPages/CustomPageEditRouterPage")).CustomPageEditRouterPage,
      meta: {
        title: "Custom Page Admin",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("impact-historical")}`,
      alias: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("impact-historical")}` === `portal-admin/:corporateId/impact-historical` ? [] : [`portal-admin/:corporateId/impact-historical`],
      name: `historical-data`,
      component: async () => (await import("@generated-routes/designPages/StatisticsHistoricalDashboardRouterPage")).StatisticsHistoricalDashboardRouterPage,
      meta: {
        title: "Historical Data",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("impact")}/${encodeURI("reports")}`,
      alias: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("impact")}/${encodeURI("reports")}` === `portal-admin/:corporateId/impact/reports` ? [] : [`portal-admin/:corporateId/impact/reports`],
      name: `impact-reports`,
      component: async () => (await import("@generated-routes/designPages/B2BStatsReportPageRouterPage")).B2BStatsReportPageRouterPage,
      meta: {
        title: "Impact (Reports)",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("impact")}/${encodeURI("statistics")}`,
      alias: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("impact")}/${encodeURI("statistics")}` === `portal-admin/:corporateId/impact/statistics` ? [] : [`portal-admin/:corporateId/impact/statistics`],
      name: `impact-statistics`,
      component: async () => (await import("@generated-routes/designPages/StatisticsDashboardRouterPage")).StatisticsDashboardRouterPage,
      meta: {
        title: "Impact (Statistics)",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("portal-design")}/${encodeURI("customize-startpage")}`,
      alias:
        `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("portal-design")}/${encodeURI("customize-startpage")}` === `portal-admin/:corporateId/portal-design/customize-startpage`
          ? []
          : [`portal-admin/:corporateId/portal-design/customize-startpage`],
      name: `start-page-admin`,
      component: async () => (await import("@generated-routes/designPages/StartPageAdminRouterPage")).StartPageAdminRouterPage,
      meta: {
        title: "Start Page Admin",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("portal-design")}/${encodeURI("portal-logo")}`,
      alias:
        `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("portal-design")}/${encodeURI("portal-logo")}` === `portal-admin/:corporateId/portal-design/portal-logo` ? [] : [`portal-admin/:corporateId/portal-design/portal-logo`],
      name: `portal-design-portal-logo`,
      component: async () => (await import("@generated-routes/designPages/CorporationLogoUploadRouterPage")).CorporationLogoUploadRouterPage,
      meta: {
        title: "Portal Design (Portal Logo)",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("portal-design")}/${encodeURI("promoboxes")}`,
      alias: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("portal-design")}/${encodeURI("promoboxes")}` === `portal-admin/:corporateId/portal-design/promoboxes` ? [] : [`portal-admin/:corporateId/portal-design/promoboxes`],
      name: `portal-design-promoboxes`,
      component: async () => (await import("@generated-routes/designPages/PromoboxAdminRouterPage")).PromoboxAdminRouterPage,
      meta: {
        title: "Portal Design (Promoboxes)",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("protection")}/${encodeURI("domain")}`,
      alias: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("protection")}/${encodeURI("domain")}` === `portal-admin/:corporateId/protection/domain` ? [] : [`portal-admin/:corporateId/protection/domain`],
      name: `protection-domain`,
      component: async () => (await import("@generated-routes/designPages/DomainProtectionEditRouterPage")).DomainProtectionEditRouterPage,
      meta: {
        title: "Protection (Domain)",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("protection")}/${encodeURI("ip")}`,
      alias: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("protection")}/${encodeURI("ip")}` === `portal-admin/:corporateId/protection/ip` ? [] : [`portal-admin/:corporateId/protection/ip`],
      name: `protection-ip`,
      component: async () => (await import("@generated-routes/designPages/IpProtectionEditRouterPage")).IpProtectionEditRouterPage,
      meta: {
        title: "Protection (IP)",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("protection")}/${encodeURI("referrer")}`,
      alias: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("protection")}/${encodeURI("referrer")}` === `portal-admin/:corporateId/protection/referrer` ? [] : [`portal-admin/:corporateId/protection/referrer`],
      name: `protection-referrer`,
      component: async () => (await import("@generated-routes/designPages/ReferrerProtectionEditRouterPage")).ReferrerProtectionEditRouterPage,
      meta: {
        title: "Protection (Referrer)",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("protection")}/${encodeURI("samlLogs")}`,
      alias: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("protection")}/${encodeURI("samlLogs")}` === `portal-admin/:corporateId/protection/samlLogs` ? [] : [`portal-admin/:corporateId/protection/samlLogs`],
      name: `protection-saml-logs`,
      component: async () => (await import("@generated-routes/designPages/SamlLogOverviewRouterPage")).SamlLogOverviewRouterPage,
      meta: {
        title: "Protection (SAML Logs)",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("protection")}/${encodeURI("sso")}`,
      alias: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("protection")}/${encodeURI("sso")}` === `portal-admin/:corporateId/protection/sso` ? [] : [`portal-admin/:corporateId/protection/sso`],
      name: `protection-sso`,
      component: async () => (await import("@generated-routes/designPages/SsoEditRouterPage")).SsoEditRouterPage,
      meta: {
        title: "Protection (SSO)",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("resources")}`,
      alias: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("resources")}` === `portal-admin/:corporateId/resources` ? [] : [`portal-admin/:corporateId/resources`],
      name: `resources`,
      component: async () => (await import("@generated-routes/designPages/ResourcesRouterPage")).ResourcesRouterPage,
      meta: {
        title: "Resources",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("users")}`,
      alias: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("users")}` === `portal-admin/:corporateId/users` ? [] : [`portal-admin/:corporateId/users`],
      name: `account-management`,
      component: async () => (await import("@generated-routes/designPages/CorporateCustomerPortalAdminRouterPage")).CorporateCustomerPortalAdminRouterPage,
      meta: {
        title: "Account Management",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("users")}/${encodeURI("custom-fields")}`,
      alias: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("users")}/${encodeURI("custom-fields")}` === `portal-admin/:corporateId/users/custom-fields` ? [] : [`portal-admin/:corporateId/users/custom-fields`],
      name: `account-management-custom-fields`,
      component: async () => (await import("@generated-routes/designPages/CustomFieldAdminRouterPage")).CustomFieldAdminRouterPage,
      meta: {
        title: "Account Management (Custom Fields)",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("users")}/${encodeURI("customer-mass-deletion")}`,
      alias:
        `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("users")}/${encodeURI("customer-mass-deletion")}` === `portal-admin/:corporateId/users/customer-mass-deletion`
          ? []
          : [`portal-admin/:corporateId/users/customer-mass-deletion`],
      name: `account-management-customer-mass-deletion`,
      component: async () => (await import("@generated-routes/designPages/CustomerMassDeletionAdminRouterPage")).CustomerMassDeletionAdminRouterPage,
      meta: {
        title: "Account Management (Customer Mass Deletion)",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("users")}/${encodeURI("customer-mass-import")}`,
      alias:
        `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("users")}/${encodeURI("customer-mass-import")}` === `portal-admin/:corporateId/users/customer-mass-import` ? [] : [`portal-admin/:corporateId/users/customer-mass-import`],
      name: `account-management-customer-mass-import`,
      component: async () => (await import("@generated-routes/designPages/CustomerMassImportAdminRouterPage")).CustomerMassImportAdminRouterPage,
      meta: {
        title: "Account Management (Customer Mass Import)",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("users")}/${encodeURI("scim")}`,
      alias: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("users")}/${encodeURI("scim")}` === `portal-admin/:corporateId/users/scim` ? [] : [`portal-admin/:corporateId/users/scim`],
      name: `account-management-scim`,
      component: async () => (await import("@generated-routes/designPages/ScimConfigRouterPage")).ScimConfigRouterPage,
      meta: {
        title: "Account Management (SCIM)",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("users")}/${encodeURI("unidentified-users")}`,
      alias: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("users")}/${encodeURI("unidentified-users")}` === `portal-admin/:corporateId/users/unidentified-users` ? [] : [`portal-admin/:corporateId/users/unidentified-users`],
      name: `account-management-unidentified-users`,
      component: async () => (await import("@generated-routes/designPages/UnidentifiedUsersAdminRouterPage")).UnidentifiedUsersAdminRouterPage,
      meta: {
        title: "Account Management (Unidentified Users)",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("users")}/${encodeURI("user-administration")}`,
      alias:
        `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("users")}/${encodeURI("user-administration")}` === `portal-admin/:corporateId/users/user-administration` ? [] : [`portal-admin/:corporateId/users/user-administration`],
      name: `account-management-user-administration`,
      component: async () => (await import("@generated-routes/designPages/CorporateCustomerPortalAdminRouterPage")).CorporateCustomerPortalAdminRouterPage,
      meta: {
        title: "Account Management (User Administration)",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("users")}/${encodeURI("user-groups")}`,
      alias: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("users")}/${encodeURI("user-groups")}` === `portal-admin/:corporateId/users/user-groups` ? [] : [`portal-admin/:corporateId/users/user-groups`],
      name: `account-management-user-groups-administration`,
      component: async () => (await import("@generated-routes/designPages/UserGroupsAdminRouterPage")).UserGroupsAdminRouterPage,
      meta: {
        title: "Account Management (User Group Administration)",
      },
      props: true,
    },
    {
      path: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("users")}/:customerId(\\d+)`,
      alias: `${encodeURI("portal-admin")}/:corporateId(\\d+)/${encodeURI("users")}/:customerId(\\d+)` === `portal-admin/:corporateId/users/:customerId` ? [] : [`portal-admin/:corporateId/users/:customerId`],
      name: `corporate-user-edit`,
      component: async () => (await import("@generated-routes/designPages/CorporateCustomerPortalAdminUserEditRouterPage")).CorporateCustomerPortalAdminUserEditRouterPage,
      meta: {
        title: "Corporate User Edit",
      },
      props: true,
    },
    {
      path: `${encodeURI("portlets")}/${encodeURI("mixedlistcustom")}/:portletId(\\d+)/${encodeURI("iframe")}`,
      alias: `${encodeURI("portlets")}/${encodeURI("mixedlistcustom")}/:portletId(\\d+)/${encodeURI("iframe")}` === `portlets/mixedlistcustom/:portletId/iframe` ? [] : [`portlets/mixedlistcustom/:portletId/iframe`],
      name: `mixed-list-portlet-iframe`,
      component: async () => (await import("@generated-routes/designPages/MixedListPortletViewAllPageRouterPage")).MixedListPortletViewAllPageRouterPage,
      meta: {
        title: "Mixed List",
        iframe: true,
      },
      props: true,
    },
    {
      path: `${encodeURI("portlets")}/${encodeURI("verifaiList")}/:portletId(\\d+)/${encodeURI("iframe")}`,
      alias: `${encodeURI("portlets")}/${encodeURI("verifaiList")}/:portletId(\\d+)/${encodeURI("iframe")}` === `portlets/verifaiList/:portletId/iframe` ? [] : [`portlets/verifaiList/:portletId/iframe`],
      name: `verifai-list-portlet-iframe`,
      component: async () => (await import("@generated-routes/designPages/OnlineContentListPortletViewAllPageRouterPage")).OnlineContentListPortletViewAllPageRouterPage,
      meta: {
        title: "Online Content",
        iframe: true,
      },
      props: true,
    },
    {
      path: `${encodeURI("quickwins")}/${encodeURI("prompt-playground")}`,
      alias: `${encodeURI("quickwins")}/${encodeURI("prompt-playground")}` === `quickwins/prompt-playground` ? [] : [`quickwins/prompt-playground`],
      name: `quickwin-prompt-playground`,
      component: async () => (await import("@generated-routes/designPages/QuickWinPromptPlaygroundRouterPage")).QuickWinPromptPlaygroundRouterPage,
      meta: {
        title: "QuickWin Prompt Playground",
      },
      props: true,
    },
    {
      path: `${encodeURI("sales-tools")}/${encodeURI("pricecalculator")}`,
      alias: `${encodeURI("sales-tools")}/${encodeURI("pricecalculator")}` === `sales-tools/pricecalculator` ? [] : [`sales-tools/pricecalculator`],
      name: `price-calculator`,
      component: async () => (await import("@generated-routes/designPages/PriceCalculatorRouterPage")).PriceCalculatorRouterPage,
      meta: {
        title: "Price Calculator",
      },
      props: true,
    },
    {
      path: `${encodeURI("skill-boosts")}/:quickWinId(\\d+)/${encodeURI("admin")}`,
      alias: `${encodeURI("skill-boosts")}/:quickWinId(\\d+)/${encodeURI("admin")}` === `skill-boosts/:quickWinId/admin` ? [] : [`skill-boosts/:quickWinId/admin`],
      name: `skill-boost-admin`,
      component: async () => (await import("@generated-routes/designPages/SkillBoostAdminPageRouterPage")).SkillBoostAdminPageRouterPage,
      meta: {
        title: "Skill Boost Admin",
      },
      props: true,
    },
    {
      path: `${encodeURI("skill-boosts")}/:quickWinId(\\d+)/${encodeURI("iframe")}`,
      alias: `${encodeURI("skill-boosts")}/:quickWinId(\\d+)/${encodeURI("iframe")}` === `skill-boosts/:quickWinId/iframe` ? [] : [`skill-boosts/:quickWinId/iframe`],
      name: `skill-boost-iframe`,
      component: async () => (await import("@generated-routes/designPages/QuickWinDetailPageRouterPage")).QuickWinDetailPageRouterPage,
      meta: {
        title: "Skill Boost",
        iframe: true,
      },
      props: true,
    },
    {
      path: `${encodeURI("skills")}/:skillId(\\d+)/${encodeURI("iframe")}`,
      alias: `${encodeURI("skills")}/:skillId(\\d+)/${encodeURI("iframe")}` === `skills/:skillId/iframe` ? [] : [`skills/:skillId/iframe`],
      name: `skills-page-iframe`,
      component: async () => (await import("@generated-routes/designPages/SkillsPageRouterPage")).SkillsPageRouterPage,
      meta: {
        title: "Skills Page",
        iframe: true,
      },
      props: true,
    },
    {
      path: `${encodeURI("skills")}/:skillName/:skillId(\\d+)/${encodeURI("iframe")}`,
      alias: `${encodeURI("skills")}/:skillName/:skillId(\\d+)/${encodeURI("iframe")}` === `skills/:skillName/:skillId/iframe` ? [] : [`skills/:skillName/:skillId/iframe`],
      name: `skills-page-iframe-with-name`,
      component: async () => (await import("@generated-routes/designPages/SkillsPageRouterPage")).SkillsPageRouterPage,
      meta: {
        title: "Skills Page",
        iframe: true,
      },
      props: true,
    },
    {
      path: `${encodeURI("stripe")}/${encodeURI("playground")}`,
      alias: `${encodeURI("stripe")}/${encodeURI("playground")}` === `stripe/playground` ? [] : [`stripe/playground`],
      name: `stripe-playground`,
      component: async () => (await import("@generated-routes/designPages/StripePlaygroundRouterPage")).StripePlaygroundRouterPage,
      meta: {
        title: "Stripe Playground",
      },
      props: true,
    },
    {
      path: `${encodeURI("subscriptions")}/${encodeURI("credit")}/:subscriptionId/:transactionTypeId/${encodeURI("admin")}`,
      alias:
        `${encodeURI("subscriptions")}/${encodeURI("credit")}/:subscriptionId/:transactionTypeId/${encodeURI("admin")}` === `subscriptions/credit/:subscriptionId/:transactionTypeId/admin`
          ? []
          : [`subscriptions/credit/:subscriptionId/:transactionTypeId/admin`],
      name: `customer-subscription-credit`,
      component: async () => (await import("@generated-routes/designPages/CustomerSubscriptionCreditPageRouterPage")).CustomerSubscriptionCreditPageRouterPage,
      meta: {
        title: "Customer Subscription Credit",
      },
      props: true,
    },
    {
      path: `${encodeURI("subscriptions")}/:subscriptionId/${encodeURI("admin")}`,
      alias: `${encodeURI("subscriptions")}/:subscriptionId/${encodeURI("admin")}` === `subscriptions/:subscriptionId/admin` ? [] : [`subscriptions/:subscriptionId/admin`],
      name: `customer-subscription`,
      component: async () => (await import("@generated-routes/designPages/CustomerSubscriptionPageRouterPage")).CustomerSubscriptionPageRouterPage,
      meta: {
        title: "Customer Subscription",
      },
      props: true,
    },
    {
      path: `${encodeURI("summary")}/:dataId(\\d+)/${encodeURI("iframe")}`,
      alias: `${encodeURI("summary")}/:dataId(\\d+)/${encodeURI("iframe")}` === `summary/:dataId/iframe` ? [] : [`summary/:dataId/iframe`],
      name: `summary-iframe`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
        iframe: true,
      },
      props: true,
    },
    {
      path: `${encodeURI("summary")}/:dataId(\\d+)/${encodeURI("iframe")}/${encodeURI("reader")}`,
      alias: `${encodeURI("summary")}/:dataId(\\d+)/${encodeURI("iframe")}/${encodeURI("reader")}` === `summary/:dataId/iframe/reader` ? [] : [`summary/:dataId/iframe/reader`],
      name: `summary-iframe-reader`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
        reader: true,
        iframe: true,
      },
      props: true,
    },
    {
      path: `${encodeURI("user-admin")}/:corporateId(\\d+)/${encodeURI("users")}`,
      alias: `${encodeURI("user-admin")}/:corporateId(\\d+)/${encodeURI("users")}` === `user-admin/:corporateId/users` ? [] : [`user-admin/:corporateId/users`],
      name: `user-management`,
      component: async () => (await import("@generated-routes/designPages/CorporateCustomerLeadPortalAdminRouterPage")).CorporateCustomerLeadPortalAdminRouterPage,
      meta: {
        title: "User Management",
      },
      props: true,
    },
    {
      path: `${encodeURI("user-admin")}/:corporateId(\\d+)/${encodeURI("users")}/:customerId(\\d+)`,
      alias: `${encodeURI("user-admin")}/:corporateId(\\d+)/${encodeURI("users")}/:customerId(\\d+)` === `user-admin/:corporateId/users/:customerId` ? [] : [`user-admin/:corporateId/users/:customerId`],
      name: `user-edit`,
      component: async () => (await import("@generated-routes/designPages/CorporateCustomerLeadPortalUserEditRouterPage")).CorporateCustomerLeadPortalUserEditRouterPage,
      meta: {
        title: "User Edit",
      },
      props: true,
    },
    {
      path: `${encodeURI("vector")}/${encodeURI("search-playground")}`,
      alias: `${encodeURI("vector")}/${encodeURI("search-playground")}` === `vector/search-playground` ? [] : [`vector/search-playground`],
      name: `vector-search-playground`,
      component: async () => (await import("@generated-routes/designPages/VectorSearchPlaygroundRouterPage")).VectorSearchPlaygroundRouterPage,
      meta: {
        title: "Vector Search Playground",
      },
      props: true,
    },
    {
      path: `${encodeURI("warmup")}`,
      alias: `${encodeURI("warmup")}` === `warmup` ? [] : [`warmup`],
      name: `warmup`,
      component: async () => (await import("@generated-routes/designPages/WarmupPageRouterPage")).WarmupPageRouterPage,
      meta: {
        title: "Warmup",
      },
      props: true,
    },
  ],
  webapp: [
    {
      path: `${encodeURI("demo")}/${encodeURI("data-patterns")}`,
      alias: `${encodeURI("demo")}/${encodeURI("data-patterns")}` === `demo/data-patterns` ? [] : [`demo/data-patterns`],
      name: `data-patterns-demo`,
      component: async () => (await import("@generated-routes/designPages/DataPatternsDemoRouterPage")).DataPatternsDemoRouterPage,
      meta: {
        title: "Data Patterns Demo",
      },
      props: true,
    },
    {
      path: `${encodeURI("demo")}/${encodeURI("summary-page-demo")}`,
      alias: `${encodeURI("demo")}/${encodeURI("summary-page-demo")}` === `demo/summary-page-demo` ? [] : [`demo/summary-page-demo`],
      name: `summary-page-demo`,
      component: async () => (await import("@generated-routes/designPages/SummaryPageDemoRouterPage")).SummaryPageDemoRouterPage,
      meta: {
        title: "Summary Page Demo",
      },
      props: true,
    },
    {
      path: `${encodeURI("explore")}`,
      alias: `${encodeURI("explore")}` === `explore` ? [] : [`explore`],
      name: `explore-skills-taxonomy`,
      component: async () => (await import("@generated-routes/designPages/ExploreSkillsPageRouterPage")).ExploreSkillsPageRouterPage,
      meta: {
        title: "Explore Skills Taxonomy",
      },
      props: true,
    },
    {
      path: `${encodeURI("mixedlistcustom")}/:portletId(\\d+)`,
      alias: `${encodeURI("mixedlistcustom")}/:portletId(\\d+)` === `mixedlistcustom/:portletId` ? [] : [`mixedlistcustom/:portletId`],
      name: `mixed-list-portlet`,
      component: async () => (await import("@generated-routes/designPages/MixedListPortletViewAllPageRouterPage")).MixedListPortletViewAllPageRouterPage,
      meta: {
        title: "Mixed List",
      },
      props: true,
    },
    {
      path: `${encodeURI("online-content")}/${encodeURI("overview")}`,
      alias: `${encodeURI("online-content")}/${encodeURI("overview")}` === `online-content/overview` ? [] : [`online-content/overview`],
      name: `online-content-overview`,
      component: async () => (await import("@generated-routes/designPages/OnlineContentOverviewPageRouterPage")).OnlineContentOverviewPageRouterPage,
      meta: {
        title: "Online Content Overview",
      },
      props: true,
    },
    {
      path: `${encodeURI("online-content")}/:onlineContentId(\\d+)`,
      alias: `${encodeURI("online-content")}/:onlineContentId(\\d+)` === `online-content/:onlineContentId` ? [] : [`online-content/:onlineContentId`],
      name: `online-content`,
      component: async () => (await import("@generated-routes/designPages/OnlineContentPageRouterPage")).OnlineContentPageRouterPage,
      meta: {
        title: "Online Content",
      },
      props: true,
    },
    {
      path: `${encodeURI("online-content")}/:onlineContentId(\\d+)/${encodeURI("reader")}`,
      alias: `${encodeURI("online-content")}/:onlineContentId(\\d+)/${encodeURI("reader")}` === `online-content/:onlineContentId/reader` ? [] : [`online-content/:onlineContentId/reader`],
      name: `online-content-detail-reader`,
      component: async () => (await import("@generated-routes/designPages/OnlineContentPageRouterPage")).OnlineContentPageRouterPage,
      meta: {
        title: "Online Content",
        reader: true,
      },
      props: true,
    },
    {
      path: `${encodeURI("portlets")}/${encodeURI("verifaiList")}/:portletId(\\d+)`,
      alias: `${encodeURI("portlets")}/${encodeURI("verifaiList")}/:portletId(\\d+)` === `portlets/verifaiList/:portletId` ? [] : [`portlets/verifaiList/:portletId`],
      name: `online-content-list-portlet`,
      component: async () => (await import("@generated-routes/designPages/OnlineContentListPortletViewAllPageRouterPage")).OnlineContentListPortletViewAllPageRouterPage,
      meta: {
        title: "Online Content",
      },
      props: true,
    },
    {
      path: `${encodeURI("resume")}/:dataId(\\d+)`,
      alias: `${encodeURI("resume")}/:dataId(\\d+)` === `resume/:dataId` ? [] : [`resume/:dataId`],
      name: `summary-fr`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
      },
      props: true,
    },
    {
      path: `${encodeURI("resume")}/:dataId(\\d+)/${encodeURI("reader")}`,
      alias: `${encodeURI("resume")}/:dataId(\\d+)/${encodeURI("reader")}` === `resume/:dataId/reader` ? [] : [`resume/:dataId/reader`],
      name: `summary-reader-fr`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
        reader: true,
      },
      props: true,
    },
    {
      path: `${encodeURI("resume")}/:name/:dataId(\\d+)`,
      alias: `${encodeURI("resume")}/:name/:dataId(\\d+)` === `resume/:name/:dataId` ? [] : [`resume/:name/:dataId`],
      name: `summary-with-name-fr`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
      },
      props: true,
    },
    {
      path: `${encodeURI("resume")}/:name/:dataId(\\d+)/${encodeURI("reader")}`,
      alias: `${encodeURI("resume")}/:name/:dataId(\\d+)/${encodeURI("reader")}` === `resume/:name/:dataId/reader` ? [] : [`resume/:name/:dataId/reader`],
      name: `summary-with-name-reader-fr`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
        reader: true,
      },
      props: true,
    },
    {
      path: `${encodeURI("resumen")}/:dataId(\\d+)`,
      alias: `${encodeURI("resumen")}/:dataId(\\d+)` === `resumen/:dataId` ? [] : [`resumen/:dataId`],
      name: `summary-es`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
      },
      props: true,
    },
    {
      path: `${encodeURI("resumen")}/:dataId(\\d+)/${encodeURI("reader")}`,
      alias: `${encodeURI("resumen")}/:dataId(\\d+)/${encodeURI("reader")}` === `resumen/:dataId/reader` ? [] : [`resumen/:dataId/reader`],
      name: `summary-reader-es`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
        reader: true,
      },
      props: true,
    },
    {
      path: `${encodeURI("resumen")}/:name/:dataId(\\d+)`,
      alias: `${encodeURI("resumen")}/:name/:dataId(\\d+)` === `resumen/:name/:dataId` ? [] : [`resumen/:name/:dataId`],
      name: `summary-with-name-es`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
      },
      props: true,
    },
    {
      path: `${encodeURI("resumen")}/:name/:dataId(\\d+)/${encodeURI("reader")}`,
      alias: `${encodeURI("resumen")}/:name/:dataId(\\d+)/${encodeURI("reader")}` === `resumen/:name/:dataId/reader` ? [] : [`resumen/:name/:dataId/reader`],
      name: `summary-with-name-reader-es`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
        reader: true,
      },
      props: true,
    },
    {
      path: `${encodeURI("resumo")}/:dataId(\\d+)`,
      alias: `${encodeURI("resumo")}/:dataId(\\d+)` === `resumo/:dataId` ? [] : [`resumo/:dataId`],
      name: `summary-pt`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
      },
      props: true,
    },
    {
      path: `${encodeURI("resumo")}/:dataId(\\d+)/${encodeURI("reader")}`,
      alias: `${encodeURI("resumo")}/:dataId(\\d+)/${encodeURI("reader")}` === `resumo/:dataId/reader` ? [] : [`resumo/:dataId/reader`],
      name: `summary-reader-pt`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
        reader: true,
      },
      props: true,
    },
    {
      path: `${encodeURI("resumo")}/:name/:dataId(\\d+)`,
      alias: `${encodeURI("resumo")}/:name/:dataId(\\d+)` === `resumo/:name/:dataId` ? [] : [`resumo/:name/:dataId`],
      name: `summary-with-name-pt`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
      },
      props: true,
    },
    {
      path: `${encodeURI("resumo")}/:name/:dataId(\\d+)/${encodeURI("reader")}`,
      alias: `${encodeURI("resumo")}/:name/:dataId(\\d+)/${encodeURI("reader")}` === `resumo/:name/:dataId/reader` ? [] : [`resumo/:name/:dataId/reader`],
      name: `summary-with-name-reader-pt`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
        reader: true,
      },
      props: true,
    },
    {
      path: `${encodeURI("skill-boosts")}/${encodeURI("my-skill-boosts")}`,
      alias: `${encodeURI("skill-boosts")}/${encodeURI("my-skill-boosts")}` === `skill-boosts/my-skill-boosts` ? [] : [`skill-boosts/my-skill-boosts`],
      name: `my-skill-boosts`,
      component: async () => (await import("@generated-routes/designPages/MyQuickWinsPageRouterPage")).MyQuickWinsPageRouterPage,
      meta: {
        title: "My Skill Boosts",
      },
      props: true,
    },
    {
      path: `${encodeURI("skills")}/:skillId(\\d+)`,
      alias: `${encodeURI("skills")}/:skillId(\\d+)` === `skills/:skillId` ? [] : [`skills/:skillId`],
      name: `skills-page`,
      component: async () => (await import("@generated-routes/designPages/SkillsPageRouterPage")).SkillsPageRouterPage,
      meta: {
        title: "Skills Page",
      },
      props: true,
    },
    {
      path: `${encodeURI("skills")}/:skillName/:skillId(\\d+)`,
      alias: `${encodeURI("skills")}/:skillName/:skillId(\\d+)` === `skills/:skillName/:skillId` ? [] : [`skills/:skillName/:skillId`],
      name: `skills-page-with-name`,
      component: async () => (await import("@generated-routes/designPages/SkillsPageRouterPage")).SkillsPageRouterPage,
      meta: {
        title: "Skills Page",
      },
      props: true,
    },
    {
      path: `${encodeURI("subscribe")}/${encodeURI("checkout")}`,
      alias: `${encodeURI("subscribe")}/${encodeURI("checkout")}` === `subscribe/checkout` ? [] : [`subscribe/checkout`],
      name: `subscribe-checkout`,
      component: async () => (await import("@generated-routes/designPages/SubscribeCheckoutPageRouterPage")).SubscribeCheckoutPageRouterPage,
      meta: {
        title: "Subscription",
      },
      props: true,
    },
    {
      path: `${encodeURI("subscribe")}/${encodeURI("complete")}`,
      alias: `${encodeURI("subscribe")}/${encodeURI("complete")}` === `subscribe/complete` ? [] : [`subscribe/complete`],
      name: `subscribe-complete`,
      component: async () => (await import("@generated-routes/designPages/SubscribeCompletePageRouterPage")).SubscribeCompletePageRouterPage,
      meta: {
        title: "Subscription",
      },
      props: true,
    },
    {
      path: `${encodeURI("summary")}/:dataId(\\d+)`,
      alias: `${encodeURI("summary")}/:dataId(\\d+)` === `summary/:dataId` ? [] : [`summary/:dataId`],
      name: `summary`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
      },
      props: true,
    },
    {
      path: `${encodeURI("summary")}/:dataId(\\d+)/${encodeURI("reader")}`,
      alias: `${encodeURI("summary")}/:dataId(\\d+)/${encodeURI("reader")}` === `summary/:dataId/reader` ? [] : [`summary/:dataId/reader`],
      name: `summary-reader`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
        reader: true,
      },
      props: true,
    },
    {
      path: `${encodeURI("summary")}/:name/:dataId(\\d+)`,
      alias: `${encodeURI("summary")}/:name/:dataId(\\d+)` === `summary/:name/:dataId` ? [] : [`summary/:name/:dataId`],
      name: `summary-with-name`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
      },
      props: true,
    },
    {
      path: `${encodeURI("summary")}/:name/:dataId(\\d+)/${encodeURI("reader")}`,
      alias: `${encodeURI("summary")}/:name/:dataId(\\d+)/${encodeURI("reader")}` === `summary/:name/:dataId/reader` ? [] : [`summary/:name/:dataId/reader`],
      name: `summary-with-name-reader`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
        reader: true,
      },
      props: true,
    },
    {
      path: `${encodeURI("zusammenfassung")}/:dataId(\\d+)`,
      alias: `${encodeURI("zusammenfassung")}/:dataId(\\d+)` === `zusammenfassung/:dataId` ? [] : [`zusammenfassung/:dataId`],
      name: `summary-de`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
      },
      props: true,
    },
    {
      path: `${encodeURI("zusammenfassung")}/:dataId(\\d+)/${encodeURI("reader")}`,
      alias: `${encodeURI("zusammenfassung")}/:dataId(\\d+)/${encodeURI("reader")}` === `zusammenfassung/:dataId/reader` ? [] : [`zusammenfassung/:dataId/reader`],
      name: `summary-reader-de`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
        reader: true,
      },
      props: true,
    },
    {
      path: `${encodeURI("zusammenfassung")}/:name/:dataId(\\d+)`,
      alias: `${encodeURI("zusammenfassung")}/:name/:dataId(\\d+)` === `zusammenfassung/:name/:dataId` ? [] : [`zusammenfassung/:name/:dataId`],
      name: `summary-with-name-de`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
      },
      props: true,
    },
    {
      path: `${encodeURI("zusammenfassung")}/:name/:dataId(\\d+)/${encodeURI("reader")}`,
      alias: `${encodeURI("zusammenfassung")}/:name/:dataId(\\d+)/${encodeURI("reader")}` === `zusammenfassung/:name/:dataId/reader` ? [] : [`zusammenfassung/:name/:dataId/reader`],
      name: `summary-with-name-reader-de`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
        reader: true,
      },
      props: true,
    },
    {
      path: `${encodeURI("Краткое-изложение")}/:dataId(\\d+)`,
      alias: `${encodeURI("Краткое-изложение")}/:dataId(\\d+)` === `Краткое-изложение/:dataId` ? [] : [`Краткое-изложение/:dataId`],
      name: `summary-ru`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
      },
      props: true,
    },
    {
      path: `${encodeURI("Краткое-изложение")}/:dataId(\\d+)/${encodeURI("reader")}`,
      alias: `${encodeURI("Краткое-изложение")}/:dataId(\\d+)/${encodeURI("reader")}` === `Краткое-изложение/:dataId/reader` ? [] : [`Краткое-изложение/:dataId/reader`],
      name: `summary-reader-ru`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
        reader: true,
      },
      props: true,
    },
    {
      path: `${encodeURI("Краткое-изложение")}/:name/:dataId(\\d+)`,
      alias: `${encodeURI("Краткое-изложение")}/:name/:dataId(\\d+)` === `Краткое-изложение/:name/:dataId` ? [] : [`Краткое-изложение/:name/:dataId`],
      name: `summary-with-name-ru`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
      },
      props: true,
    },
    {
      path: `${encodeURI("Краткое-изложение")}/:name/:dataId(\\d+)/${encodeURI("reader")}`,
      alias: `${encodeURI("Краткое-изложение")}/:name/:dataId(\\d+)/${encodeURI("reader")}` === `Краткое-изложение/:name/:dataId/reader` ? [] : [`Краткое-изложение/:name/:dataId/reader`],
      name: `summary-with-name-reader-ru`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
        reader: true,
      },
      props: true,
    },
    {
      path: `${encodeURI("ملخص")}/:dataId(\\d+)`,
      alias: `${encodeURI("ملخص")}/:dataId(\\d+)` === `ملخص/:dataId` ? [] : [`ملخص/:dataId`],
      name: `summary-ar`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
      },
      props: true,
    },
    {
      path: `${encodeURI("ملخص")}/:dataId(\\d+)/${encodeURI("reader")}`,
      alias: `${encodeURI("ملخص")}/:dataId(\\d+)/${encodeURI("reader")}` === `ملخص/:dataId/reader` ? [] : [`ملخص/:dataId/reader`],
      name: `summary-reader-ar`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
        reader: true,
      },
      props: true,
    },
    {
      path: `${encodeURI("ملخص")}/:name/:dataId(\\d+)`,
      alias: `${encodeURI("ملخص")}/:name/:dataId(\\d+)` === `ملخص/:name/:dataId` ? [] : [`ملخص/:name/:dataId`],
      name: `summary-with-name-ar`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
      },
      props: true,
    },
    {
      path: `${encodeURI("ملخص")}/:name/:dataId(\\d+)/${encodeURI("reader")}`,
      alias: `${encodeURI("ملخص")}/:name/:dataId(\\d+)/${encodeURI("reader")}` === `ملخص/:name/:dataId/reader` ? [] : [`ملخص/:name/:dataId/reader`],
      name: `summary-with-name-reader-ar`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
        reader: true,
      },
      props: true,
    },
    {
      path: `${encodeURI("摘要")}/:dataId(\\d+)`,
      alias: `${encodeURI("摘要")}/:dataId(\\d+)` === `摘要/:dataId` ? [] : [`摘要/:dataId`],
      name: `summary-zh`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
      },
      props: true,
    },
    {
      path: `${encodeURI("摘要")}/:dataId(\\d+)/${encodeURI("reader")}`,
      alias: `${encodeURI("摘要")}/:dataId(\\d+)/${encodeURI("reader")}` === `摘要/:dataId/reader` ? [] : [`摘要/:dataId/reader`],
      name: `summary-reader-zh`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
        reader: true,
      },
      props: true,
    },
    {
      path: `${encodeURI("摘要")}/:name/:dataId(\\d+)`,
      alias: `${encodeURI("摘要")}/:name/:dataId(\\d+)` === `摘要/:name/:dataId` ? [] : [`摘要/:name/:dataId`],
      name: `summary-with-name-zh`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
      },
      props: true,
    },
    {
      path: `${encodeURI("摘要")}/:name/:dataId(\\d+)/${encodeURI("reader")}`,
      alias: `${encodeURI("摘要")}/:name/:dataId(\\d+)/${encodeURI("reader")}` === `摘要/:name/:dataId/reader` ? [] : [`摘要/:name/:dataId/reader`],
      name: `summary-with-name-reader-zh`,
      component: async () => (await import("@generated-routes/designPages/SummarySpaRouterPage")).SummarySpaRouterPage,
      meta: {
        title: "Summary",
        reader: true,
      },
      props: true,
    },
  ],
};
export function getLocalizedSummaryUrlWithDataId(language: Language, dataId: string): string {
  switch (language) {
    case "de":
      return `/zusammenfassung/${dataId}`;
    case "es":
      return `/resumen/${dataId}`;
    case "ru":
      return `/Краткое-изложение/${dataId}`;
    case "zh":
      return `/摘要/${dataId}`;
    case "ar":
      return `/ملخص/${dataId}`;
    case "pt":
      return `/resumo/${dataId}`;
    case "fr":
      return `/resume/${dataId}`;
    default:
      return `/summary/${dataId}`;
  }
}
export function getLocalizedSummaryReaderUrlWithDataId(language: Language, dataId: string): string {
  switch (language) {
    case "de":
      return `/zusammenfassung/${dataId}/reader`;
    case "es":
      return `/resumen/${dataId}/reader`;
    case "ru":
      return `/Краткое-изложение/${dataId}/reader`;
    case "zh":
      return `/摘要/${dataId}/reader`;
    case "ar":
      return `/ملخص/${dataId}/reader`;
    case "pt":
      return `/resumo/${dataId}/reader`;
    case "fr":
      return `/resume/${dataId}/reader`;
    default:
      return `/summary/${dataId}/reader`;
  }
}
export function getLocalizedSummaryUrlWithNameAndDataId(language: Language, name: string, dataId: string): string {
  switch (language) {
    case "de":
      return `/zusammenfassung/${name}/${dataId}`;
    case "es":
      return `/resumen/${name}/${dataId}`;
    case "ru":
      return `/Краткое-изложение/${name}/${dataId}`;
    case "zh":
      return `/摘要/${name}/${dataId}`;
    case "ar":
      return `/ملخص/${name}/${dataId}`;
    case "pt":
      return `/resumo/${name}/${dataId}`;
    case "fr":
      return `/resume/${name}/${dataId}`;
    default:
      return `/summary/${name}/${dataId}`;
  }
}
export function getLocalizedSummaryReaderUrlWithNameAndDataId(language: Language, name: string, dataId: string): string {
  switch (language) {
    case "de":
      return `/zusammenfassung/${name}/${dataId}/reader`;
    case "es":
      return `/resumen/${name}/${dataId}/reader`;
    case "ru":
      return `/Краткое-изложение/${name}/${dataId}/reader`;
    case "zh":
      return `/摘要/${name}/${dataId}/reader`;
    case "ar":
      return `/ملخص/${name}/${dataId}/reader`;
    case "pt":
      return `/resumo/${name}/${dataId}/reader`;
    case "fr":
      return `/resume/${name}/${dataId}/reader`;
    default:
      return `/summary/${name}/${dataId}/reader`;
  }
}
